// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605131047/js/" + chunkId + "." + {"44":"363edfd1","225":"6fafd076","481":"9a0b8b52","486":"cf5d84a0","770":"af775631"}[chunkId] + ".0.23751163221110994.chunk.js";
};